import React, { useState, useRef } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box
} from '@mui/material';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

interface ImageCropperProps {
    open: boolean;
    onClose: () => void;
    onCropComplete: (croppedImageUrl: string, croppedBlob: Blob) => void;
    aspectRatio?: number; // 幅/高さの比率（デフォルトは4:3）
    imageFile: File | null;
}

const ImageCropper: React.FC<ImageCropperProps> = ({
    open,
    onClose,
    onCropComplete,
    aspectRatio = 4 / 3, // デフォルトは4:3
    imageFile
}) => {
    const [imageSrc, setImageSrc] = useState<string | null>(null);
    const cropperRef = useRef<HTMLImageElement>(null);

    React.useEffect(() => {
        if (imageFile) {
            const reader = new FileReader();
            reader.onload = () => {
                setImageSrc(reader.result as string);
            };
            reader.readAsDataURL(imageFile);
        }
    }, [imageFile]);

    const handleCrop = () => {
        const imageElement: any = cropperRef?.current;
        const cropper: any = imageElement?.cropper;

        if (cropper) {
            // キャンバスからトリミングされた画像を取得
            cropper.getCroppedCanvas().toBlob((blob: Blob) => {
                if (blob) {
                    const croppedImageUrl = URL.createObjectURL(blob);
                    onCropComplete(croppedImageUrl, blob);
                    onClose();
                }
            });
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>画像をトリミング</DialogTitle>
            <DialogContent>
                <Box sx={{ height: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {imageSrc && (
                        <Cropper
                            src={imageSrc}
                            style={{ height: '100%', width: '100%' }}
                            aspectRatio={aspectRatio}
                            guides={true}
                            ref={cropperRef}
                            viewMode={1}
                            minCropBoxHeight={10}
                            minCropBoxWidth={10}
                            background={false}
                            responsive={true}
                            autoCropArea={1}
                            checkOrientation={false}
                        />
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    キャンセル
                </Button>
                <Button onClick={handleCrop} color="primary" variant="contained">
                    トリミングを確定
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImageCropper;